import { createContext, useContext, useRef } from "react";
import { createStore, useStore } from "zustand";

export type BroadcastUser = {
  id: number;
};

export interface InitialState {
  online_users?: Array<BroadcastUser>;
}

export interface MessengerState {
  online_users: Array<BroadcastUser>;

  setOnlineUsers: (users: Array<BroadcastUser>) => void;
  addOnlineUser: (user: BroadcastUser) => void;
  removeOnlineUser: (user: BroadcastUser) => void;
}

export const createMessengerStore = (init: InitialState) => {
  return createStore<MessengerState>((set) => ({
    online_users: [],
    ...init,
    setOnlineUsers: (users) => set({ online_users: users }),
    addOnlineUser: (user) =>
      set((state) => ({
        online_users: [
          ...state.online_users.filter((u) => u.id !== user.id),
          user,
        ],
      })),
    removeOnlineUser: (user) =>
      set((state) => ({
        online_users: state.online_users.filter((u) => u.id !== user.id),
      })),
  }));
};

type MessengerStore = ReturnType<typeof createMessengerStore>;

export const MessengerContext = createContext<MessengerStore | null>(null);

export function useCreateMessengerStore(init: InitialState) {
  const messengerStore = useRef<MessengerStore>(undefined);

  if (!messengerStore.current) {
    messengerStore.current = createMessengerStore(init);
  }

  return messengerStore.current;
}

function useMessengerStore() {
  const store = useContext(MessengerContext);
  if (!store) throw new Error("Missing BuilderContext.Provider in the tree");
  return store;
}

export function useMessengerContext<T>(
  selector: (state: MessengerState) => T,
): T {
  return useStore(useMessengerStore(), selector);
}
